import { render } from "./MascotIntro.vue?vue&type=template&id=2d748563&scoped=true"
import script from "./MascotIntro.vue?vue&type=script&lang=js"
export * from "./MascotIntro.vue?vue&type=script&lang=js"

import "./MascotIntro.vue?vue&type=style&index=0&id=2d748563&scoped=true&lang=css"

import exportComponent from "/Users/tavishi/Desktop/Tilly/code/tern-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d748563"]])

export default __exports__